module.exports = __webpack_public_path__ + "static/media/08.dace8212.jpg";